/* Sign-of-the-Day overrides for the SITE (read-only).
 *
 * Overrides are set in /admin/sotd, stored server-side in sotd-api.php, and
 * baked into src/data/sotdOverridesData.js at build time (see
 * scripts/fetch-sotd-overrides.mjs). The site just reads that baked map - it
 * no longer touches localStorage, so every visitor sees the same sign and the
 * prerendered pages / OG images match. Writing overrides lives in
 * src/lib/sotdAdminApi.js.
 *
 * Override shape mirrors the baseline schedule entry:
 *   { name, slug, image, description, dateLong }
 */
import { SOTD_OVERRIDES } from "../data/sotdOverridesData";
import { SOTD_CURATED } from "../data/sotdCurated";

/* Resolution priority: /admin (DB) override  >  curated editorial calendar
   >  baseline rotation. A DB override still wins so the admin can amend any
   day, including a curated one. */
export const getOverride = (yyyymmdd) =>
  SOTD_OVERRIDES[yyyymmdd] || SOTD_CURATED[yyyymmdd] || null;

export const getAllOverrides = () => ({ ...SOTD_CURATED, ...SOTD_OVERRIDES });

/* Merge baseline schedule + curated + baked DB overrides into one resolved map. */
export const buildResolvedSchedule = (baseline) =>
  Object.keys(baseline).reduce((acc, k) => {
    acc[k] = SOTD_OVERRIDES[k] || SOTD_CURATED[k] || baseline[k];
    return acc;
  }, {});
